import React from 'react';
import './MyAccountV2.scss';
import MyAccountHeader from './MyAccountHeader';
import MyAccountNavigation from './MyAccountTabs';
import { useMyAccountTabs } from './MyAccountTabs/useMyAccountTabs';
import SettingsTab from "./MyAccountTabs/SettingsTab";
import DocumentsTab from "./MyAccountTabs/DocumentsTab";
import EcardTab from "./MyAccountTabs/EcardTab";
import TicketsTab from "./MyAccountTabs/TicketsTab";
import ReservationsTab from "./MyAccountTabs/ReservationsTab";

const MyAccountV2: React.FC = () => {
  const { activeTab, setActiveTab } = useMyAccountTabs();

  const getTabComponent = () => {
    switch (activeTab) {
      case "documents":
        return <DocumentsTab />;
      case "settings":
        return <SettingsTab />;
      case "ecard":
        return <EcardTab />;
      case "tickets":
        return <TicketsTab />;
      case "reservations":
        return <ReservationsTab />;
    }
    return <p>Placeholder dla: {activeTab}</p>;
  };

  return (
    <div className="my-account-v2">
      <MyAccountHeader />
      <MyAccountNavigation activeTab={activeTab} onTabChange={setActiveTab} />
      <div className="my-account-v2__content">{getTabComponent()}</div>
    </div>
  );
};

export default MyAccountV2;
